import type { GridV1Widget } from './grid-v1-types';

const CELL_ID_PATTERN = /^cell-(\d+)$/;

export function nextGridV1CellId(widgets: GridV1Widget[]): string {
  let max = 0;
  for (const widget of widgets) {
    const match = CELL_ID_PATTERN.exec(widget.id);
    if (match) {
      const n = Number.parseInt(match[1] ?? '0', 10);
      if (n > max) max = n;
    }
  }
  return `cell-${max + 1}`;
}

export function defaultNewGridV1WidgetLayout(columnCount = 12): {
  w: number;
  h: number;
} {
  const columns = columnCount > 0 ? columnCount : 12;
  return {
    w: Math.min(6, columns),
    h: 3,
  };
}
